<template>
  <div>
    <section class="catalogue-results">
      <div class="catalogue-results-inner max-width side-padding appear">
        <h1 class="title-medium centered">Catalogo</h1>
        <catalog-results-breadcrumb :results="results" :repertorio="repertorio" :artist="artist" :genre="genre" :orderBy="orderBy" :page="page" :album="album" :song="song"></catalog-results-breadcrumb>
        <div v-if="results && results.data && results.data.length > 0">
          <catalog-results-results :results="results" :isExpandedResult="isExpandedResult" :genre="genre" :song="song"></catalog-results-results>
        </div>
        <div v-else>
          <p class="no-results">Spiacenti, la ricerca non ha prodotto risultati</p>
        </div>
        <div v-if="isLoading" class="loader">Sto caricando...</div>
        <catalog-results-navigation :results="results" :isLoading="isLoading"></catalog-results-navigation>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios/dist/axios';
import CatalogResultsResults from './CatalogResultsResults.vue';
import CatalogResultsBreadcrumb from './CatalogResultsBreadcrumb.vue';
import CatalogResultsNavigation from './CatalogResultsNavigation.vue';

export default {
  props: ['repertorio', 'artist', 'genre', 'orderBy', 'page', 'album', 'song', 'queryId'],
  
  data() {
    return {
      results: {},
      isExpandedResult: false,
      isLoading: false
    }
  },
  
  mounted() {
    this.update();
  },

  watch: {
    queryId: function() {
      this.update();
    }
  },

  methods: {
    update: function() {
      let queryType = 'filterable';
      let queryString = window.location.origin + '/api/v1/album/list?';
      this.isExpandedResult = false;

      if(this.repertorio.activeId != -1) {
        queryString += 'category_id=' + this.repertorio.activeId + '&';
      }
      if(this.artist.activeId != -1) {
        queryString += 'artist_id=' + this.artist.activeId + '&';
      }
      if(this.genre.activeId != -1) {
        queryString += 'genre_id=' + this.genre.activeId + '&';
        this.isExpandedResult = true;
      }

      if(Object.keys(this.album.selectedData).length !== 0 && this.album.selectedData.constructor === Object && this.album.activeId != -1) {
        queryType = 'album';
        queryString += 'album_id=' + this.album.activeId + '&';
      }

      if(Object.keys(this.song.selectedData).length !== 0 && this.song.selectedData.constructor === Object && this.song.activeId != -1) {
        queryType = 'song';
        queryString += 'song_id=' + this.song.activeId + '&';
        this.isExpandedResult = true;
      }
      
      const id = this.orderBy.activeId == 'per-data' ? 'date' : 'artist';
      queryString += 'orderby=' + id + '&';
      queryString += 'page=' + this.page;

      this.isLoading = true;
      axios.get(queryString).then(resp => {
        if(this.page > 1 && Object.keys(this.results).length) {
          const previousData = JSON.parse(JSON.stringify(this.results.data));
          const currentData = JSON.parse(JSON.stringify(resp.data.data));
          const allData = previousData.concat(currentData);
          this.results = resp.data;
          this.results.data = allData;
        } else {
          this.results = resp.data;
        }
        this.isLoading = false;
      });
    }
  },

  components: {
    'catalog-results-results': CatalogResultsResults,
    'catalog-results-breadcrumb': CatalogResultsBreadcrumb,
    'catalog-results-navigation': CatalogResultsNavigation
  }
}
</script>

<style lang="scss" scoped>
@import './../css/variables.css';

.loader {
  text-align: center;
  margin: 20px 0;
}

.no-results {
  text-align: center;
  padding: 20px 0;
  font-size: 18px;
  font-family: Oswald, arial, sans-serif;
  background: var(--aqua);
}

</style>


// WEBPACK FOOTER //
// src/vue/components/CatalogResults.vue